module.exports = __webpack_public_path__ + "img/Icon_Historial_de_Facturas_Hover.810ae1f7.svg";